import { render } from "./SuperAdminOrganizationsTable.vue?vue&type=template&id=717ceb47&scoped=true"
import script from "./SuperAdminOrganizationsTable.vue?vue&type=script&lang=js"
export * from "./SuperAdminOrganizationsTable.vue?vue&type=script&lang=js"

import "./SuperAdminOrganizationsTable.vue?vue&type=style&index=0&id=717ceb47&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717ceb47"]])

export default __exports__